import React, { useState, useEffect } from 'react';
import './CB.css'; 
import TestUpdate from "./TestUpdate";
import CreateReport from "./CreateReport";
import { API_URL } from './API';

const CircuitBreakerForm = ({ block, plant, instrument, project, goBack, reportToUpdate, isUpdateMode }) => {
  const [formData1, setformData1] = useState({
    description: '',
    date: '',
    project: '',
    reportNo: '',
    customer: '',
    client: '',
    location: '',
    make: '',
    ratedFrequency: '',
    serialNumber: '',
    insulationLevel: '',
    productionYear: '',
    closingCoilSupplyVolts: '',
    ratedVoltage: '',
    openingCoilSupplyVolts: '',
    ratedCurrent: '',
    motorSupplyVolts: ''
  });
 
  const [showBackPage, setShowBackPage] = useState(false);
  const [showTestPage, setShowTestPage] = useState(false);
  const [rows, setRows] = useState([]);
  const [generalInspection, setGeneralInspection] = useState({});

  const fetchClientName = async (clientId) => {
    try {
      const response = await fetch(`${API_URL}/clients/get_client`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        mode: 'cors',
      });
      
      if (response.ok) {
        const result = await response.json();
        let clientsData = Array.isArray(result) ? result : result.data || result.clients || [];
        const client = clientsData.find(c => c.client_id === clientId || c.id === clientId);
        return client ? client.client_name : "Unknown Client";
      }
    } catch (error) {
     
    }
    return "Unknown Client";
  };
  

  useEffect(() => {
    
    if (isUpdateMode && reportToUpdate?.test_data) {
      try {
       
        
        const testData = reportToUpdate.test_data || {};
        const circuitBreakerData = testData.circuitBreakerData || {};
        
       
        const extractCBData = (data) => {
          if (!data || typeof data !== 'object') return {};
          
          
          const result = {};
          Object.keys(data).forEach(key => {
            if (data[key] && typeof data[key] === 'object' && data[key].reading_1) {
             
              result[key] = data[key].reading_1 || Object.values(data[key])[0] || '';
            } else if (Array.isArray(data[key])) {
              result[key] = data[key][0] || '';
            } else {
              result[key] = data[key] || '';
            }
          });
          return result;
        };
        
        const extractedData = extractCBData(circuitBreakerData);
        
        const loadedData = {
          description: extractedData.description || circuitBreakerData.description || 'CIRCUIT BREAKER INSPECTION / TEST REPORT',
          date: extractedData.date || circuitBreakerData.date || reportToUpdate.test_date || '',
          project: extractedData.project || circuitBreakerData.project || reportToUpdate.sub_project_name || '',
          reportNo: extractedData.reportNo || circuitBreakerData.reportNo || reportToUpdate.report_no || '',
          customer: extractedData.customer || circuitBreakerData.customer || '',
          client: extractedData.client || circuitBreakerData.client || '',
          location: extractedData.location || circuitBreakerData.location || reportToUpdate.location || '',
          make: extractedData.make || circuitBreakerData.make || '',
          ratedFrequency: extractedData.ratedFrequency || circuitBreakerData.ratedFrequency || '',
          serialNumber: extractedData.serialNumber || circuitBreakerData.serialNumber || '',
          insulationLevel: extractedData.insulationLevel || circuitBreakerData.insulationLevel || '',
          productionYear: extractedData.productionYear || circuitBreakerData.productionYear || '',
          closingCoilSupplyVolts: extractedData.closingCoilSupplyVolts || circuitBreakerData.closingCoilSupplyVolts || '',
          ratedVoltage: extractedData.ratedVoltage || circuitBreakerData.ratedVoltage || '',
          openingCoilSupplyVolts: extractedData.openingCoilSupplyVolts || circuitBreakerData.openingCoilSupplyVolts || '',
          ratedCurrent: extractedData.ratedCurrent || circuitBreakerData.ratedCurrent || '',
          motorSupplyVolts: extractedData.motorSupplyVolts || circuitBreakerData.motorSupplyVolts || ''
        };
        
        setformData1(loadedData);
        
       
        localStorage.setItem('updatecircuitBreakerFormData', JSON.stringify(loadedData));
        
      } catch (error) {
       
      }
    } else {
      
      const savedData = localStorage.getItem('updatecircuitBreakerFormData');
      if (savedData) {
        try {
          const parsedData = JSON.parse(savedData);
          setformData1(parsedData);
        } catch (error) {
          
        }
      }
    }
  }, [isUpdateMode, reportToUpdate]);

  
  useEffect(() => {
    const loadProjectData = async () => {
      if (project) {
        let clientName = project?.clientName || project?.client_name;
        
        if (!clientName && project?.client) {
          clientName = await fetchClientName(project.client);
        }
        
        setformData1(prevData => ({
          ...prevData,
          project: project?.name || '',
          client: clientName || ''
          
        }));
      }
    };
    
    loadProjectData();
  }, [project]);

 
useEffect(() => {
 
  if (formData1 && Object.keys(formData1).length > 0) {
    localStorage.setItem('updatecircuitBreakerFormData', JSON.stringify(formData1));
   
  }
}, [formData1]);
  
const handleInputChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;
    
    switch(name) {
      case 'description':
        newValue = value.replace(/[^a-zA-Z/\s]/g, '');
        break;
      
      case 'customer':
      case 'client':
        newValue = value.replace(/[^a-zA-Z\s]/g, '');
        break;
      
      case 'make':
        newValue = value.replace(/[^a-zA-Z0-9\s]/g, '');
        break;
      
      case 'project':
        newValue = value.replace(/[^a-zA-Z0-9\s,]/g, '');
        break;
      
      case 'ratedFrequency':
      case 'ratedVoltage':
      case 'ratedCurrent':
      case 'serialNumber':
      case 'closingCoilSupplyVolts':
      case 'openingCoilSupplyVolts':
      case 'motorSupplyVolts':
        newValue = value.replace(/[^a-zA-Z0-9\s]/g, '');
        break;
      
      case 'reportNo':
        newValue = value.replace(/[^a-zA-Z0-9\-\s]/g, '');
        break;
      
      case 'location':
        newValue = value.replace(/[^a-zA-Z0-9\-\s,]/g, '');
        break;
      
      case 'insulationLevel':
        newValue = value.replace(/[^a-zA-Z0-9/\s]/g, '');
        break;
      
      case 'productionYear':
        newValue = value.replace(/[^0-9]/g, '').slice(0, 4);
        break;
        
      default:
        break;
    }
  
    const updatedData = {
      ...formData1,
      [name]: newValue
    };
    
    setformData1(updatedData);
    
   
    localStorage.setItem('updatecircuitBreakerFormData', JSON.stringify(updatedData));
    
  };
  
  const handleNextClick = () => {
 
    setShowTestPage(true);
  };
  
  const handleBackClick = () => {
  
    setShowBackPage(true);
  };
  
  if (showBackPage) {
    return <CreateReport goBack={() => setShowBackPage(false)} savedGeneralformData1={formData1} />;
  }

  if (showTestPage) {
    return <TestUpdate 
      goBack={() => setShowTestPage(false)} 
      savedGeneralData={{
        formData1,
        rows,
        generalInspection
      }}
      reportToUpdate={reportToUpdate}
      isUpdateMode={isUpdateMode}
    />;
  }

const redirectToHome = () => {
  if (window.confirm("Are you sure you want to leave this page? Any unsaved changes will be lost.")) {  
    localStorage.setItem('openReportsOnLoad', 'true');
    window.location.href = "/";
  }
};

  return (
    <div className="CB-00">
      <span 
          style={{ 
            display: 'flex',
            justifyContent: 'flex-end',
            fontSize: '20px', 
            fontWeight: '600', 
            color: '#333', 
            cursor: 'pointer',
            marginLeft: '50px',
            marginBottom: '50px'
          }}
          onClick={redirectToHome}
        >
          X
        </span>

     

      <div className="CB-01">
        <div className="CB-02">
          <h1 className='CB-03'>Circuit Breaker Inspection / Test (CB)</h1>
        </div>
        <div className="CB-04">
          <div className="CB-05">
            <div className="CB-06">
              <label>Description </label>
              <input 
                type="text" 
                name="description"
                value="CIRCUIT BREAKER INSPECTION / TEST REPORT"
                onChange={handleInputChange}
                placeholder="Enter Description" 
                readOnly={"description"}
                  style={"description" ? { 
                 
                cursor: 'not-allowed'
              } : {}}
              />
            </div>
            <div className="CB-06">
              <label>Date </label>
              <input 
                type="date" 
                name="date"
                value={formData1.date || ''}
                onChange={handleInputChange}
              />
            </div>
            <div className="CB-06">
              <label>Project </label>
              <input 
                type="text" 
                name="project"
                value={formData1.project || ''}
                onChange={handleInputChange}
                placeholder="Enter Project" 
                readOnly={"project"}
                  style={"project" ? { 
                 
                cursor: 'not-allowed'
              } : {}}
              />
            </div>
          </div>

          <div className="CB-05">
            <div className="CB-06">
              <label>Report No </label>
              <input 
                type="text" 
                name="reportNo"
                value={formData1.reportNo || ''}
                onChange={handleInputChange}
                placeholder="Enter Report No" 
              />
            </div>
            <div className="CB-06">
              <label>Customer </label>
              <input 
                type="text" 
                name="customer"
                value={formData1.customer || ''}
                onChange={handleInputChange}
                placeholder="Enter Customer" 
              />
            </div>
            <div className="CB-06">
              <label>Client </label>
              <input 
                type="text" 
                name="client"
                value={formData1.client || ''}
                onChange={handleInputChange}
                placeholder="Enter Client" 
                readOnly={"client"}
                  style={"client" ? { 
                 
                cursor: 'not-allowed'
              } : {}}
              />
            </div>
          </div>

          <div className="CB-05">
            <div className="CB-07">
              <label>Location </label>
              <input 
                type="text" 
                name="location"
                value={formData1.location || ''}
                onChange={handleInputChange}
                placeholder="Enter Location" 
               
              />
            </div>
          </div>
        </div>
      </div>

      <div className="CB-08">
        <div className="CB-02">
          <h2 className='CB-03'>Name Plate Details</h2>
        </div>
        <div className="CB-04">
          <div className="CB-05">
            <div className="CB-06">
              <label>Make </label>
              <input 
                type="text" 
                name="make"
                value={formData1.make || ''}
                onChange={handleInputChange}
                placeholder="Enter Make" 
              />
            </div>
            <div className="CB-06">
              <label>Rated Frequency </label>
              <input 
                type="text" 
                name="ratedFrequency"
                value={formData1.ratedFrequency || ''}
                onChange={handleInputChange}
                placeholder="Enter Rated Frequency " 
              />
            </div>
            <div className="CB-06">
              <label>Serial Number </label>
              <input 
                type="text" 
                name="serialNumber"
                value={formData1.serialNumber || ''}
                onChange={handleInputChange}
                placeholder="Enter Serial Number" 
              />
            </div>
          </div>
          
          <div className="CB-05">
            <div className="CB-06">
              <label>Insulation Level </label>
              <input 
                type="text" 
                name="insulationLevel"
                value={formData1.insulationLevel || ''}
                onChange={handleInputChange}
                placeholder="Enter Insulation Level" 
              />
            </div>
            <div className="CB-06">
              <label>Production Year </label>
              <input 
                type="text" 
                name="productionYear"
                value={formData1.productionYear || ''}
                onChange={handleInputChange}
                placeholder="Enter Production Year " 
              />
            </div>
            <div className="CB-06">
              <label>Closing Coil Supply Volts </label>
              <input 
                type="text" 
                name="closingCoilSupplyVolts"
                value={formData1.closingCoilSupplyVolts || ''}
                onChange={handleInputChange}
                placeholder="Enter Closing Coil Supply Volts " 
              />
            </div>
          </div>
          
          <div className="CB-05">
            <div className="CB-06">
              <label>Rated Voltage </label>
              <input 
                type="text" 
                name="ratedVoltage"
                value={formData1.ratedVoltage || ''}
                onChange={handleInputChange}
                placeholder="Enter Rated Voltage" 
              />
            </div>
            <div className="CB-06">
              <label>Opening Coil Supply Volts </label>
              <input 
                type="text" 
                name="openingCoilSupplyVolts"
                value={formData1.openingCoilSupplyVolts || ''}
                onChange={handleInputChange}
                placeholder="Enter Opening Coil Supply Volts" 
              />
            </div>
            <div className="CB-06">
              <label>Rated Current </label>
              <input 
                type="text" 
                name="ratedCurrent"
                value={formData1.ratedCurrent || ''}
                onChange={handleInputChange}
                placeholder="Enter Rated Current" 
              />
            </div>
          </div>
          
          <div className="CB-05">
            <div className="CB-07">
              <label>Motor Supply Volts </label>
              <input 
                type="text" 
                name="motorSupplyVolts"
                value={formData1.motorSupplyVolts || ''}
                onChange={handleInputChange}
                placeholder="Enter Motor Supply Volts" 
              />
            </div>
          </div>
        </div>
      </div>
      
      <div className="CB-09">
        <button 
          className="CB-10" 
         onClick={goBack}
          type="button"
        >
          Back
        </button>
        <button 
          className="CB-11" 
          onClick={handleNextClick}
          type="button"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default CircuitBreakerForm;